import {
	ADD_REGION,
	ADD_REGION_SUCCESS,
	ADD_REGION_FAIL,
	ADD_REGION_RESET,
} from '../actions/addRegionAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const addRegionReducer = (state = initialState, action) => {
	switch (action.type) {
		case ADD_REGION:
			return {
				...state,
				apiState: 'loading',
			};
		case ADD_REGION_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case ADD_REGION_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case ADD_REGION_RESET:
			return initialState;
		default:
			return state;
	}
};

export default addRegionReducer;
